import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InterviewMatch {
  email: string;
  userId: string;
}

const initialState: InterviewMatch[] = [];

const interviewMatchSlice = createSlice({
  name: 'interviewMatch',
  initialState,
  reducers: {
    addMatch: (
      state,
      action: PayloadAction<{ email: string; userId: string }>
    ) => {
      const exists = state.find(
        (match) => match.userId === action.payload.userId
      );

      if (!exists) {
        state.push(action.payload);
      }
    },

    removeMatch: (state, action: PayloadAction<string>) => {
      return state.filter((match) => match.userId !== action.payload);
    },
  },
});

export const { addMatch, removeMatch } = interviewMatchSlice.actions;

export default interviewMatchSlice.reducer;
